module.exports = __webpack_public_path__ + "img/default-identity-img.308b5ab5.png";